import API from "../configs/axiosInstance";

const getIssueRemedy = (params = {}) => {
    return API({
        url: '/issue-service/v1/open-ai/remedy-vulnerability',
        method: 'GET',
        params
    });
};

const approveRemediationStep = ({ stepId, approved }) => {
    return API({
        url: '/issue-service/v1/open-ai/remedy/step/approve',
        method: 'POST',
        data: { stepId, approved }
    });
};

const aiService = {
    getIssueRemedy,
    approveRemediationStep
};

export default aiService;